import { render, staticRenderFns } from "./login copy.vue?vue&type=template&id=448b24ca&"
import script from "./login copy.vue?vue&type=script&lang=js&"
export * from "./login copy.vue?vue&type=script&lang=js&"
import style0 from "./login copy.vue?vue&type=style&index=0&id=448b24ca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports